import { useNavigate } from "react-router-dom"

import Style from "./style"

import useGetExamResult from "entity/tryoutExam/useGetExamResult"

import DefaultButton from "shared/ui/DefaultButton"
import { convertProGradeAsName } from "shared/constant/lookup/proGrade"

const TryoutExamResult = () => {
    const navigate = useNavigate()

    const [getExamResult] = useGetExamResult()

    return (
        <Style.Wrapper>

            <Style.TitleDiv>
                <h2>{convertProGradeAsName[getExamResult?.data?.pro_grade_flag]} 프로 필기 시험 결과</h2>
                <Style.InfoDiv>
                    <h2>커트라인 점수</h2>
                    <p>{getExamResult?.data?.cutoff}점</p>
                </Style.InfoDiv>
                <Style.InfoDiv>
                    <h2>획득 점수</h2>
                    <p>{getExamResult?.data?.grade}점</p>
                </Style.InfoDiv>
                <Style.InfoDiv>
                    <h2>결과</h2>
                    <p>{getExamResult?.data?.is_pass ? "합격" : "불합격"}</p>
                </Style.InfoDiv>
            </Style.TitleDiv>

            {getExamResult?.data?.is_pass &&
                <Style.ContentDiv>
                    <h2>Basic {convertProGradeAsName[getExamResult?.data?.pro_grade_flag]} Pro</h2>
                    <p>필기 시험 합격을 축하드립니다.</p>
                </Style.ContentDiv>
            }

            <DefaultButton clickEvent={() => navigate("/my/tryout/record")}>목록으로 돌아가기</DefaultButton>

        </Style.Wrapper>
    )
}

export default TryoutExamResult